import { render, staticRenderFns } from "./danshi1.vue?vue&type=template&id=61499191&"
import script from "./danshi1.vue?vue&type=script&lang=js&"
export * from "./danshi1.vue?vue&type=script&lang=js&"
import style0 from "./danshi1.vue?vue&type=style&index=0&id=61499191&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports